module.exports = __webpack_public_path__ + "static/ins2-c38408b73cc188ea87289a48bd6e0cb9.png";